/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Directory/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import ArrowRight from 'DesignSystem/Svgs/ArrowRight/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Directory({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Documents/Navigation/Breadcrumb/Documents/Directory"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let patientDocumentsDirectoryItemIsFirstValueData = fromData.useDataValue({ viewPath,
context: 'patient_documents_directory_item',
path: 'isFirst',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isHovered
  
})
let patientDocumentsDirectoryNameValueData = fromData.useDataValue({ viewPath,
context: 'patient_documents_directory',
path: 'name',
})
  return (<React.Fragment
>
<div
  data-testid="Directory.Horizontal"
  data-view-path={viewPath}
 style={{'--ml-1-1ecXqh': patientDocumentsDirectoryItemIsFirstValueData ? "0px" : typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<ArrowRight
  viewPath={`${viewPath}/ArrowRight`}
 width={12}
 height={12}
 stroke="rgba(0,0,0,0.3)"
/>
<button
  data-testid="Directory.Horizontal:1"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--ml-1-1ecXqh': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbc-2-1ecXqh': isHovered ? "rgba(0,188,112, 1)" : "rgba(0,188,112, 0)"}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="patient_documents_directory.name"
 text={patientDocumentsDirectoryNameValueData}
/>
</button>
</div>
{children}
</React.Fragment>)
}